"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createClient = exports.cache = exports.fragmentMatcher = void 0;
const client_1 = require("@apollo/client");
const apollo_cache_inmemory_1 = require("apollo-cache-inmemory");
const createLink_1 = require("./createLink");
const resolvers_1 = require("./resolvers");
const fragmentTypes_json_1 = __importDefault(require("./fragmentTypes.json"));
exports.fragmentMatcher = new apollo_cache_inmemory_1.IntrospectionFragmentMatcher({ introspectionQueryResultData: fragmentTypes_json_1.default });
exports.cache = new client_1.InMemoryCache({
    typePolicies: {
        APIPortProperty: { keyFields: false },
        AcceptEntityDTO: { keyFields: false },
        AcceptState: { keyFields: false },
        AccountDTO: { keyFields: ['key'] },
        AccountMutation: { keyFields: false },
        AccountUserRole: { keyFields: ['systemUserAcl', 'userId'] },
        AdministrativeDomainDTO: { keyFields: false },
        AssetCandidate: { keyFields: false },
        AssetState: { keyFields: false },
        AuthenticateInput: { keyFields: false },
        AuthenticationServer: { keyFields: false },
        BatteryPowerDefinition: { keyFields: false },
        BinaryMessageType: { keyFields: false },
        BinaryWrapperDTO: { keyFields: false },
        BlobDTO: { keyFields: false },
        Booking: { keyFields: false },
        Boolean: { keyFields: false },
        BucketConsumption: { keyFields: false },
        BucketType: { keyFields: false },
        Capability: { keyFields: false },
        ClientInfoDTO: { keyFields: false },
        ClientUserInfoDTO: { keyFields: false },
        CommandDTO: { keyFields: false },
        CommandName: { keyFields: false },
        CopDTO: { keyFields: false },
        CreateUnitInput: { keyFields: false },
        CustomPropertyDTO: { keyFields: false },
        DataSourceAddress: { keyFields: false },
        DataSourceDTO: { keyFields: false },
        DataTransformation: { keyFields: false },
        DeployState: { keyFields: false },
        DeviceAcceptState: { keyFields: false },
        DeviceUpState: { keyFields: false },
        DrainingState: { keyFields: false },
        ElectricalPhaseDTO: { keyFields: false },
        Envelope: { keyFields: false },
        EventDTO: { keyFields: false },
        EventType: { keyFields: false },
        FactoryDefaultType: { keyFields: false },
        Float: { keyFields: false },
        Floor: { keyFields: false },
        FloorStatus: { keyFields: false },
        FloorWarnings: { keyFields: false },
        Function: { keyFields: false },
        GatewayType: { keyFields: false },
        GeoJsonFeature: { keyFields: false },
        GeoJsonFeatureCollection: { keyFields: false },
        Health: { keyFields: false },
        HealthStatus: { keyFields: false },
        ID: { keyFields: false },
        InstallStatus: { keyFields: false },
        InstallStep: { keyFields: false },
        Int: { keyFields: false },
        InventoryItemDTO: { keyFields: false },
        InventoryListDTO: { keyFields: false },
        KeyValueDTO: { keyFields: false },
        Language: { keyFields: false },
        Layer: { keyFields: false },
        LayerType: { keyFields: false },
        LevelState: { keyFields: false },
        LifeCycleState: { keyFields: false },
        LinkServerDTO: { keyFields: false },
        LocalConnectionDTO: { keyFields: false },
        LocationAddress: { keyFields: false },
        LocationDTO: { keyFields: ['key'] },
        LocationDTO2: { keyFields: false },
        LocationGatewayStatus: { keyFields: false },
        LocationMutation: { keyFields: false },
        LoginState: { keyFields: false },
        Long: { keyFields: false },
        Manifest: { keyFields: false },
        MatchDTO: { keyFields: false },
        MatchName: { keyFields: false },
        MatchType: { keyFields: false },
        MessageIdentifier: { keyFields: false },
        Mutation: { keyFields: false },
        NamedPropertyInput: { keyFields: false },
        NativeClientDTO: { keyFields: false },
        OnlineStatusDTO: { keyFields: false },
        Ontology: { keyFields: false },
        OpenClosedState: { keyFields: false },
        OperatingPowerState: { keyFields: false },
        OutputValue: { keyFields: false },
        Paginated: { keyFields: false },
        PaginatedCustomPropertyDTO: { keyFields: false },
        PaginatedLocationDTO: { keyFields: false },
        PaginatedPlannedDeviceDTO: { keyFields: false },
        PaginatedProvisioningDTO: { keyFields: false },
        PaginatedUnitDTO: { keyFields: false },
        PairDTO: { keyFields: false },
        PeeringInput: { keyFields: false },
        PeeringResponseCode: { keyFields: false },
        PlanDTO: { keyFields: ['key'] },
        PlannedDeviceDTO: { keyFields: ['id'] },
        PlannedDeviceInput: { keyFields: false },
        Point: { keyFields: false },
        PointSeries: { keyFields: false },
        PointType: { keyFields: false },
        PointWithMaxMin: { keyFields: false },
        PortalService: { keyFields: false },
        PositionInput: { keyFields: false },
        PositionType: { keyFields: false },
        PowerType: { keyFields: false },
        PropertyDTO: { keyFields: false },
        PropertyInput: { keyFields: false },
        PropertyName: { keyFields: false },
        ProspectMutation: { keyFields: false },
        ProvisioningDTO: { keyFields: false },
        PushPolicy: { keyFields: false },
        PushPolicyLevel: { keyFields: false },
        PushPolicyState: { keyFields: false },
        Query: { keyFields: false },
        RadioComStatsDTO: { keyFields: false },
        Range: { keyFields: false },
        RealmDTO: { keyFields: false },
        RefillableType: { keyFields: false },
        ResourceDTO: { keyFields: false },
        ResponseCode: { keyFields: false },
        Sample: { keyFields: ['time'] },
        SampleAccelerometer: { keyFields: ['time'] },
        SampleAsset: { keyFields: ['time'] },
        SampleBattery: { keyFields: ['time'] },
        SampleBatteryPower: { keyFields: ['time'] },
        SampleBoolean: { keyFields: ['time'] },
        SampleBooleanCounter: { keyFields: ['time'] },
        SampleCO2: { keyFields: ['time'] },
        SampleCommunicationStatistics: { keyFields: ['time'] },
        SampleDTO: { keyFields: ['time'] },
        SampleDispenser: { keyFields: ['time'] },
        SampleDistance: { keyFields: ['time'] },
        SampleDouble: { keyFields: ['time'] },
        SampleDraining: { keyFields: ['time'] },
        SampleElectrical: { keyFields: ['time'] },
        SampleElectricalEnergySimple: { keyFields: ['time'] },
        SampleEndOfSlot: { keyFields: ['time'] },
        SampleFootfall: { keyFields: ['time'] },
        SampleForce: { keyFields: ['time'] },
        SampleGeneric: { keyFields: ['time'] },
        SampleGyro: { keyFields: ['time'] },
        SampleHeartRatePeriod: { keyFields: ['time'] },
        SampleHumidity: { keyFields: ['time'] },
        SampleIlluminance: { keyFields: ['time'] },
        SampleImage: { keyFields: ['time'] },
        SampleImageTime: { keyFields: ['time'] },
        SampleLamp: { keyFields: ['time'] },
        SampleList: { keyFields: false },
        SampleLog: { keyFields: ['time'] },
        SampleLong: { keyFields: ['time'] },
        SampleMotion: { keyFields: ['time'] },
        SampleMotion2Lars: { keyFields: ['time'] },
        SampleNodeStatistics: { keyFields: ['time'] },
        SampleOnOff: { keyFields: ['time'] },
        SampleOpenClosed: { keyFields: ['time'] },
        SampleParticulateMatter: { keyFields: ['time'] },
        SamplePeopleCount: { keyFields: ['time'] },
        SamplePercentage: { keyFields: ['time'] },
        SamplePosition: { keyFields: false },
        SamplePowerUpdate: { keyFields: ['time'] },
        SamplePressure: { keyFields: ['time'] },
        SamplePulseBand: { keyFields: ['time'] },
        SampleRefillList: { keyFields: ['time'] },
        SampleSiteOnlineStatus: { keyFields: ['time'] },
        SampleSoundClassification: { keyFields: ['time'] },
        SampleSoundPressureLevel: { keyFields: ['time'] },
        SampleStack: { keyFields: ['time'] },
        SampleStatus: { keyFields: ['time'] },
        SampleString: { keyFields: ['time'] },
        SampleTemp: { keyFields: ['time'] },
        SampleUpState: { keyFields: ['time'] },
        SampleUtilization: { keyFields: ['time'] },
        SampleVOC: { keyFields: ['time'] },
        SampleWeight: { keyFields: ['time'] },
        ServerCategory: { keyFields: false },
        ServiceDefinitionDTO: { keyFields: false },
        ServiceDetailsDTO: { keyFields: false },
        ServiceRole: { keyFields: false },
        Severity: { keyFields: false },
        ShrekDTO: { keyFields: false },
        SiUnit: { keyFields: false },
        SlotDTO: { keyFields: false },
        SlotSize: { keyFields: false },
        StateCounts: { keyFields: false },
        Status: { keyFields: false },
        String: { keyFields: false },
        SubscribeData: { keyFields: false },
        Subscription: { keyFields: false },
        SubscriptionType: { keyFields: false },
        SystemUserAcl: { keyFields: false },
        TimeSerieSelectionInput: { keyFields: false },
        UnitAcl: { keyFields: false },
        UnitAddress: { keyFields: ['key'] },
        UnitAlarmSetValues: { keyFields: false },
        UnitDTO: {
            keyFields: ['key'],
            fields: { ontology: { merge: (prev, next) => (Object.assign(Object.assign({}, prev), next)) } },
        },
        UnitFilterInput: { keyFields: false },
        UnitMutation: { keyFields: false },
        UnitPhysicalness: { keyFields: false },
        UnitProperty: { keyFields: false },
        UnitType: { keyFields: false },
        UserDTO: { keyFields: ['key'] },
        UserProperty: { keyFields: false },
        ValueTypeDTO: { keyFields: false },
        VariableName: { keyFields: false },
        VersionType: { keyFields: false },
        Warning: { keyFields: false },
        __Directive: { keyFields: false },
        __DirectiveLocation: { keyFields: false },
        __EnumValue: { keyFields: false },
        __Field: { keyFields: false },
        __InputValue: { keyFields: false },
        __Schema: { keyFields: false },
        __Type: { keyFields: false },
        __TypeKind: { keyFields: false },
    },
});
function createClient(socket, errorHandler) {
    return new client_1.ApolloClient({
        link: createLink_1.createLink(socket, errorHandler),
        cache: exports.cache,
        fragmentMatcher: exports.fragmentMatcher.match,
        connectToDevTools: process.env.NODE_ENV === 'development',
        defaultOptions: {
            watchQuery: { fetchPolicy: 'cache-and-network' },
            query: { fetchPolicy: 'cache-first' },
        },
        resolvers: resolvers_1.resolvers,
    });
}
exports.createClient = createClient;
//# sourceMappingURL=createClient.js.map